import React from 'react'
import { useTranslation } from 'react-i18next'

import Stack from '@mui/material/Stack'

import { Log } from '../../types/log'
import Alert from '../alert/alert'
import { weightValueToDisplay } from '../../utils/weightUtils'

interface UpdateInventoryAlertProps {
  oldLog: Log
  patchedLog: Log
}

const UpdateInventoryAlert = (props: UpdateInventoryAlertProps): JSX.Element => {
  const { t } = useTranslation()

  let weightToAdd = 0
  let addName: string | undefined = ''
  let weightToSubtract = 0
  let subtractName: string | undefined = ''
  if (
    !!props.patchedLog.inventory_id &&
    props.oldLog.inventory_id === props.patchedLog.inventory_id &&
    Math.round(props.oldLog.start_weight || 0) > Math.round(props.patchedLog.start_weight || 0)
  ) {
    weightToAdd = (props.oldLog.start_weight || 0) - (props.patchedLog.start_weight || 0)
    addName = props.patchedLog.inventory_name
  }
  if (
    props.oldLog.inventory_id !== props.patchedLog.inventory_id &&
    !!props.patchedLog.start_weight &&
    !!props.oldLog.inventory_id
  ) {
    weightToAdd = props.patchedLog.start_weight
    addName = props.oldLog.inventory_name
  }
  if (
    !!props.patchedLog.inventory_id &&
    props.oldLog.inventory_id === props.patchedLog.inventory_id &&
    Math.round(props.oldLog.start_weight || 0) < Math.round(props.patchedLog.start_weight || 0)
  ) {
    weightToSubtract = (props.patchedLog.start_weight || 0) - (props.oldLog.start_weight || 0)
    subtractName = props.patchedLog.inventory_name
  }
  if (
    props.oldLog.inventory_id !== props.patchedLog.inventory_id &&
    !!props.patchedLog.start_weight &&
    !!props.patchedLog.inventory_id
  ) {
    weightToSubtract = props.patchedLog.start_weight
    subtractName = props.patchedLog.inventory_name
  }
  // check if there is enough weight to subtract from inventory
  if (
    weightToSubtract > (props.patchedLog.inventory_current_weight || 0) &&
    subtractName === props.patchedLog.inventory_name
  ) {
    return (
      <Alert severity="error">
        {t('logview.notenoughweight')
          .replace('{0}', weightValueToDisplay(props.patchedLog.inventory_current_weight || 0))
          .replace('{1}', subtractName || '')}
      </Alert>
    )
  }
  return (
    <Stack spacing={1}>
      {weightToAdd > 0 && (
        <Alert severity="info">
          {t('logview.addweightinfo')
            .replace('{0}', weightValueToDisplay(weightToAdd))
            .replace('{1}', addName || '')}
        </Alert>
      )}
      {weightToSubtract > 0 && (
        <Alert severity="info">
          {t('logview.substractweightinfo')
            .replace('{0}', weightValueToDisplay(weightToSubtract))
            .replace('{1}', subtractName || '')}
        </Alert>
      )}
    </Stack>
  )
}

export default UpdateInventoryAlert
